import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StepContainer = styled.ul`
  display: inherit;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin: 30px;
  border-radius: 20px;
  list-style: none;
`;

export const List = styled.ul`
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 30%;
  margin: 0.5rem;
  list-style: none;
`;

export const Step = styled.li`
  color: ${({ active, closed }) => (active || closed ? "#FFF" : "#2E5A87")};
  font-size: 1.2rem;
  font-weight: bold;
  background: ${({ active, closed }) =>
    active || closed ? "#0000FF" : "#0A1E32"};
  border-width: 1px;
  border-style: solid;
  border-color: ${({ active, closed }) =>
    active || closed ? "#0000FF" : "#2E5A87"};
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
